import { render } from "./GetSiteLogo.vue?vue&type=template&id=b84e4df4&scoped=true"
import script from "./GetSiteLogo.vue?vue&type=script&lang=js"
export * from "./GetSiteLogo.vue?vue&type=script&lang=js"

import "./GetSiteLogo.vue?vue&type=style&index=0&id=b84e4df4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b84e4df4"],['__file',"src/scripts/view/portfolio/sections/_helper/GetSiteLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b84e4df4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b84e4df4', __exports__)) {
    api.reload('b84e4df4', __exports__)
  }
  
  module.hot.accept("./GetSiteLogo.vue?vue&type=template&id=b84e4df4&scoped=true", () => {
    api.rerender('b84e4df4', render)
  })

}


export default __exports__